export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const BASE_URL = `${API_URL}/api/v1`;
